import { useEffect, useCallback, useRef } from "react";

const useInfiniteScroll = (callback, { margin = 50 } = {}) => {//브라우저 확대시 재생목록 페이징 안되는 이슈가 있어 margin값 올림
	// 스크롤 이벤트를 등록할 ref
	const container = useRef(null);

	// callback 이 실행 중인지 확인을 위한 ref
	const running = useRef(false);

	// 스크롤 이벤트
	const handleScroll = useCallback(
		async (e) => {
			const target = e.target;

			// 스크롤이 끝까지 닿았을 경우 callback 실행
			if (target.scrollHeight - margin <= target.offsetHeight + target.scrollTop && !running.current) {
				running.current = true;
				await callback();
				running.current = false;
			}
		},
		[callback, margin],
	);

	// 스크롤 이벤트 관리
	useEffect(() => {
		const target = container.current;

		// 스크롤 이벤트 등록
		if (target && typeof target.addEventListener === "function") {
			target.addEventListener("scroll", handleScroll);
		}

		return () => {
			// 스크롤 이벤트 제거
			if (target && typeof target.removeEventListener === "function") {
				target.removeEventListener("scroll", handleScroll);
			}
		};
	}, [handleScroll]);

	return container;
};

export default useInfiniteScroll;
